import { render, staticRenderFns } from "./IrrigationDetail.vue?vue&type=template&id=67b386fc&scoped=true&"
import script from "./IrrigationDetail.vue?vue&type=script&lang=ts&"
export * from "./IrrigationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./IrrigationDetail.vue?vue&type=style&index=0&id=67b386fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b386fc",
  null
  
)

export default component.exports